import React from 'react';
import { Box, AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NotificationCenter from './notifications/NotificationCenter';
import Navigation from './Navigation';
import Logo from './Logo';
import { useAuth } from '../context/AuthContext';
import { Outlet } from 'react-router-dom';

export function Layout() {
  const { logout } = useAuth();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
      <Navigation />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          p: 3, 
          mt: '64px', // Height of the AppBar
          width: 'calc(100% - 64px)', // Adjust width to account for the collapsed drawer
          transition: 'width 0.3s ease',
          overflow: 'auto'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
